import React from "react";
import BlogCard from "../../components/common/BlogCard/BlogCard";
import Heading from "../../components/common/Typography/Heading";
import {
  PUBLIC_CARD_GRID_GAP_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const Blogs = [
  {
    link: "",
    blogName: "Fixing a Leaky Tap: A Step-by-Step Guide",
    text: "Discover the simple steps to tighten up that pesky leak yourself.",
  },
  {
    link: "",
    blogName: "When to Call a Plumber: Mixer Repair Edition",
    text: "Learn the signs that indicate it’s time to call in the professionals.",
  },
  {
    link: "",
    blogName: "Choosing the Right Mixer for Your Kitchen",
    text: "A comprehensive guide to selecting a mixer that combines functionality with style.",
  },
];
const BlogsMobile = [
  {
    link: "",
    blogName: "Fixing a Leaky Tap: A Step-by-Step Guide",
    text: "Discover the simple steps to tighten up that pesky leak yourself.",
  },
  {
    link: "",
    blogName: "When to Call a Plumber: Mixer Repair Edition",
    text: "Learn the signs that indicate it’s time to call in the professionals.",
  },
  {
    link: "",
    blogName: "Choosing the Right Mixer for Your Kitchen",
    text: "A comprehensive guide to selecting a mixer that combines functionality with style.",
  },
  {
    link: "",
    blogName: "Choosing the Right Mixer for Your Kitchen",
    text: "A comprehensive guide to selecting a mixer that combines functionality with style.",
  },
];

const Tips = () => {
  return (
    <div className={`tp-container-main mx-auto ${PUBLIC_SECTION_GAP_CLASS}`}>
      <Heading variant={"h2"} className={"text-offblack"}>
        How to guides
      </Heading>
      <div className={`lg:hidden flex justify-center ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 mx-auto w-fit ${PUBLIC_CARD_GRID_GAP_CLASS}`}
        >
          {BlogsMobile.map((e, index) => (
            <BlogCard
              link={e.link}
              key={index}
              blogName={e.blogName.split(/\s+/).slice(0, 9).join(" ")}
              text={e.text}
              blogTitle={e.blogTitle}
            />
          ))}
        </div>
      </div>
      <div className={`hidden lg:flex justify-center ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}>
        <div className={`grid lg:grid-cols-3 mx-auto w-fit ${PUBLIC_CARD_GRID_GAP_CLASS}`}>
          {Blogs.map((e, index) => (
            <BlogCard
              link={e.link}
              key={index}
              blogName={e.blogName.split(/\s+/).slice(0, 9).join(" ")}
              text={e.text}
              blogTitle={e.blogTitle}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tips;
